export default __webpack_public_path__ + "static/media/contacto.941b6680.png";